<template>
	<accountLayout :title="$t('account.loginTitle')" :subtitle="$t('account.loginSubtitle')" current="account"
		ref="layout">
		<el-form :model="form" :rules="rules" ref="form" @submit.native.prevent="onSubmit"
			:label-position="labelPosition" :label-width="labelWidth">
			<el-form-item prop="email" :label="$t('account.email')">
				<el-input v-model="form.email" :placeholder="$t('account.email')"></el-input>
			</el-form-item>
			<el-form-item prop="password" :label="$t('account.password')">
				<el-input v-model="form.password" type="password" show-password
					:placeholder="$t('account.password')"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button class="account-submit-btn" :loading="loading" @click="onSubmit"
					style="width:100%">{{ $t('account.login') }}</el-button>
			</el-form-item>
		</el-form>
		<div class="account-links">
			<span>{{ $t('account.noAccount') }}</span>
			<router-link :to="langPrefix + '/register'">{{ $t('account.goRegister') }}</router-link>
			<!-- <a href="javascript:;" @click="goResend">{{ $t('account.resendActivation') }}</a> -->
		</div>
	</accountLayout>
</template>

<script>
import accountLayout from "@/components/c/accountLayout.vue"
import { accountLoginApi, resendActivationApi } from "@/api/login.js"
export default {
	components: { accountLayout },
	data() {
		return {
			form: { email: '', password: '' },
			loading: false,
			labelPosition: window.innerWidth >= 1200 ? 'left' : 'top',
			labelWidth: window.innerWidth >= 1200 ? '120px' : 'auto',
			rules: {
				email: [
					{ required: true, message: this.$t('account.emailRequired'), trigger: 'blur' },
					{ type: 'email', message: this.$t('account.emailInvalid'), trigger: 'blur' }
				],
				password: [{ required: true, message: this.$t('account.passwordRequired'), trigger: 'blur' }]
			}
		}
	},
	computed: {
		langPrefix() {
			const l = localStorage.getItem('i18n-lang') || 'zh'
			return l == 'zh' ? '/cn' : '/en'
		}
	},
	mounted() {
		window.addEventListener('resize', this.handleResize)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize)
	},
	methods: {
		handleResize() {
			this.labelPosition = window.innerWidth >= 1200 ? 'left' : 'top'
			this.labelWidth = window.innerWidth >= 1200 ? '120px' : 'auto'
		},
		onSubmit() {
			this.$refs.form.validate(valid => {
				if (!valid) return
				this.loading = true
				accountLoginApi(this.form).then(res => {
					localStorage.setItem('user_token', res.data.access_token)
					localStorage.setItem('user_id', res.data.user.id)
					localStorage.setItem('user_name', res.data.user.email)
					this.$store.commit('setUserName', res.data.user.email)
					const realName = res.data.user.name || localStorage.getItem('user_real_name')
					if (realName) {
						localStorage.setItem('user_real_name', realName)
						this.$store.commit('setUserRealName', realName)
					}
					this.$message.success(this.$t('account.loginSuccess'))
					const redirect = this.$route.query.redirect
					this.$router.push(redirect || this.langPrefix)
				}).catch(() => {}).finally(() => { this.loading = false })
			})
		},
		goResend() {
			this.$prompt(this.$t('account.enterEmail'), this.$t('account.resendActivation'), {
				confirmButtonText: this.$t('account.confirm'),
				cancelButtonText: this.$t('account.cancel'),
				inputPattern: /[^@]+@[^@]+\.[^@]+/,
				inputErrorMessage: this.$t('account.emailInvalid')
			}).then(({ value }) => {
				resendActivationApi({ email: value }).then(() => {
					this.$message.success(this.$t('account.resent'))
				}).catch(() => {})
			}).catch(() => {})
		}
	}
}
</script>

<style scoped lang="scss">
.account-submit-btn {
	background: #000000;
	border-color: #000000;
	color: #FFFFFF;
	height: 44px;
	border-radius: 0;
	font-size: 15px;

	&:hover,
	&:focus {
		background: #333333;
		border-color: #333333;
		color: #FFFFFF;
	}
}

.account-links {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 8px;
	font-size: 14px;
	margin-top: 20px;

	span {
		color: #999999;
	}

	a {
		color: #000000;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}
}

@media screen and (max-width: 768px) {
	.account-links {
		flex-direction: column;
		gap: 6px;
	}
}
</style>
